import { createFileRoute } from "@tanstack/react-router";
import type { Row } from "@tanstack/react-table";
import { zodValidator } from "@tanstack/zod-adapter";
import { useState } from "react";

import ActionButton from "@/components/Button/ActionButton";
import { DataTable } from "@/components/DataTable";
import { FillScreen, HStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";

import { DeviceAssignmentDialog } from "./-components/device-assignment-dialog";
import { InventoryTabs, useInventoryTabs } from "./-components/InventoryTabs";
import { SearchSchema } from "./-constants";
import { useLicenseDeviceTable } from "./-hooks/useLicenseDeviceTable";
import type { LicenseDeviceTableRow } from "./-types";

export const Route = createFileRoute(
  "/_staff/licenses/$id/_profile/assignments/",
)({
  validateSearch: zodValidator(SearchSchema),
  component: LicenseDevices,
});

function LicenseDevices() {
  const { id } = Route.useParams();
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.licenses.detailDevices",
  });

  const navigate = Route.useNavigate();
  // const search = Route.useSearch();

  const { table, displayState, counts, allocationType } =
    useLicenseDeviceTable();

  // const handleFilterInput = useDebouncedCallback(
  //   (e: ChangeEvent<HTMLInputElement>) =>
  //     navigate({
  //       search: (prev) => ({ ...prev, pageIndex: 0, freeText: e.target.value }),
  //     }),
  //   [navigate],
  // );
  const inventoryTabsProps = useInventoryTabs();
  const [isOpen, setIsOpen] = useState(false);

  const handleRowClick = (row: Row<LicenseDeviceTableRow>) => {
    const data = row.original;
    if (data.type === "USER_BASED") {
      if (data.worker?.id) {
        navigate({
          to: "/person/$id",
          params: { id: data.worker.id },
        });
      }
    } else {
      if (data.device?.id) {
        navigate({
          to: "/profile/device/$id",
          params: { id: data.device.id },
        });
      }
    }
  };

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <HStack className="gap-2 items-center">
        <InventoryTabs
          counts={counts}
          onChange={inventoryTabsProps.onChange}
          value={inventoryTabsProps.value}
        />
        {allocationType === "DEVICE_BASED" && (
          <>
            <span className="ml-auto">
              <ActionButton
                variant="secondary"
                size="sm"
                onClick={() => setIsOpen(true)}
              >
                {t("assignButton")}
              </ActionButton>
            </span>
            <DeviceAssignmentDialog
              licenseId={id}
              title={t("deviceAssignmentDialog.title")}
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              onSuccess={() => {}}
            />
          </>
        )}
      </HStack>
      <DataTable
        table={table}
        displayState={displayState}
        onRowClick={handleRowClick}
      />
    </FillScreen>
  );
}
